import AlertMessage from "./AlertMessage";
import styles from "./ApiErrorAlert.module.css";
import type { apiErrorAlertProps } from "./types.props";

const ApiErrorAlert = ({
    error,
    title = "Ocurrió un error",
}: apiErrorAlertProps) => {
    if (!error) {
        return null;
    }

    const fieldErrors = Object.entries(error.fieldErrors);

    return (
        <AlertMessage type="error" title={title}>
            <div className={styles["message-body"]}>{error.generalMessage}</div>

            {fieldErrors.length > 0 && (
                <ul className={styles["field-errors-list"]}>
                    {fieldErrors.map(([field, message]) => (
                        <li key={field}>
                            <strong>{field}:</strong> {message}
                        </li>
                    ))}
                </ul>
            )}
        </AlertMessage>
    );
};

export default ApiErrorAlert;
